module.exports = __webpack_public_path__ + "static/media/network.6dfb679f.svg";